import {useEffect, useState, useRef, useDeferredValue} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../../../selectors/layers/main/game';
import {openGame, toggleFavorite} from '../../../../../reducers/user/actions';

export default ({props}) => {
    const {button, favorite_button, favorites} = useSelector(Selector),
          dispatch = useDispatch();

    return (
        <div className="game">
            <div className="border" onClick={e => {
                if(button)
                    return;

                dispatch(openGame(props.id));
            }}></div>
            <div className="favorite" onClick={e => {
                if(!favorite_button)
                    dispatch(toggleFavorite(props.id));
            }}>
                <div className={`status ${favorites.includes(props.id) ? 'active' : ''}`}></div>
                <div className="fav-border"></div>
            </div>
            <div className="image">
                <img
                    src={`${props.animation.asset}`}
                    width={props.animation.frame.width}
                    height={props.animation.frame.height}
                    alt={props.name} />
            </div>
        </div>
    )    
}